<template>
  <div class="app">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 2" :key="item" cols="2">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in 4" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row dense>
        <v-col cols="3">
          <v-text-field
            dense
            v-model="form.acao.description"
            :counter="35"
            label="Descrição"
            :error-messages="descriptionErrors"
            @input="$v.form.acao.description.$touch()"
            @blur="$v.form.acao.description.$touch()"
          />
        </v-col>
        <v-col cols="2" class="ml-14">
          <v-switch dense v-model="form.active" label="Ativo" />
        </v-col>
        <v-col cols="3">
          <v-switch dense v-model="form.acao.continuar" label="Executar Próxima Ação Válida" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-row>
            <v-col>
              <v-text-field
                dense
                v-model="form.regexVisualOrigem"
                :error-messages="regexVisualOrigemErrors"
                :counter="20"
                label="Expressão de Origem"
                @input="
                  $v.form.regexVisualOrigem.$touch()
                  form.regexVisualOrigem = $event.trim()
                "
                @blur="$v.form.regexVisualOrigem.$touch()"
              />
            </v-col>
            <v-col>
              <v-text-field
                dense
                v-model="form.regexVisualDestino"
                :error-messages="regexVisualDestinoErrors"
                :counter="20"
                label="Expressão de Destino"
                @input="
                  $v.form.regexVisualDestino.$touch()
                  form.regexVisualDestino = $event.trim()
                "
                @blur="$v.form.regexVisualDestino.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                dense
                v-model="form.alliasRegexOrigem"
                label="Grupos de Expressões Origem"
                :items="alliasRegexOrigem"
              />
            </v-col>
            <v-col>
              <v-select
                dense
                v-model="form.alliasRegexDestino"
                label="Grupos de Expressões Destino"
                :items="alliasRegexDestino"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <v-col>
              <v-select
                dense
                v-model="form.acao.centroDeCusto"
                :error-messages="centroDeCustoErrors"
                :items="centroDeCusto"
                label="Centro de Custo"
                @input="$v.form.acao.centroDeCusto.$touch()"
                @blur="$v.form.acao.centroDeCusto.$touch()"
              />
            </v-col>
            <v-col>
              <v-select
                dense
                v-model="form.acao.ura_id"
                :error-messages="uraErrors"
                :items="ura"
                label="URA"
                @input="$v.form.acao.ura_id.$touch()"
                @blur="$v.form.acao.ura_id.$touch()"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select dense multiple v-model="form.acao.tag" :items="tags" label="Tags">
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">{{ item.text }}</span>
                  <v-chip v-if="index === 1" small>
                    <span class="caption"> (+{{ form.acao.tag.length - 1 }}) </span>
                  </v-chip>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item ripple @click="toggleTags">
                    <v-list-item-action>
                      <v-icon :color="form.acao.tag.length > 0 ? 'indigo darken-4' : ''">
                        {{ iconTags }}
                      </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        Selecionar Todas
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2" />
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import rotasStore from '../../../../store'

import { rotasMixin } from '../_mixins/rotasMixins'
import { validateData, validateComputed } from '../_validates/validateTocarUra'

export default {
  name: 'TocarUra',
  mixins: [validationMixin, rotasMixin],
  data: () => ({
    form: {
      description: 'DISCAR PARA URA',
      regexVisualOrigem: '',
      regexVisualDestino: '',
      alliasRegexOrigem: '',
      alliasRegexDestino: '',
      active: true,
      acao: {
        description: 'DISCAR PARA URA',
        class: 'Modules\\Agi\\Entities\\acoes\\TocarUra',
        centroDeCusto: '',
        tag: [],
        ura_id: '',
        continuar: false,
      },
    },
    ura: [],
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('tocarUraAcoesRotasModulePABXStore', ['getUras']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'tocarUraAcoesRotasModulePABXStore', rotasStore)

    await Promise.all([this.listarUras(), this.listarCentroDeCustos(), this.listarRegex(), this.listarTags()])

    this.getItemsSelectCentroDeCusto()
    this.getItemsSelectRegexOrigemEDestino()
    this.getItemsSelectTags()

    this.ura = this.getUras.map(ura => ({ value: ura._id, text: ura.description }))

    this.makeFormulario()

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('tocarUraAcoesRotasModulePABXStore', ['listarUras']),
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
